import Flickity from 'flickity';

const expandedClass = 'is-expanded';

export function init() {
	const toggles = Array.from(document.querySelectorAll('.js-disclosure'));

	toggles.forEach(element => {
		let isExpanded = false;
		let targetId = element.dataset.target;

		let target = document.getElementById(targetId);
		let label = element.querySelector('.js-disclosure-label');

		if (!target) {
			return;
		}

		close();

		let flkty = Flickity.data(target.firstElementChild);
		target.removeAttribute('hidden');
		element.removeAttribute('hidden');
		element.setAttribute('aria-controls', targetId);
		element.setAttribute('aria-expanded', 'false');
		element.addEventListener('click', toggle);

		function toggle() {
			isExpanded ? close() : open();
		}

		function open() {
			isExpanded = true;

			target.style.display = 'block';
			target.classList.add(expandedClass);
			element.classList.add(expandedClass);
			element.setAttribute('aria-expanded', 'true');

			if (label) {
				label.textContent = label.textContent.replace(/show/i, 'Hide');
			}

			if (flkty) {
				flkty.resize();
			}
		}

		function close() {
			isExpanded = false;

			target.style.display = 'none';
			target.classList.remove(expandedClass);
			element.classList.remove(expandedClass);
			element.setAttribute('aria-expanded', 'false');

			if (label) {
				label.textContent = label.textContent.replace(/hide/i, 'Show');
			}
		}
	});
}
